import { apiClient } from "./client";
import type { Message } from "@abejon/shared";

export interface MessageWithSender extends Message {
  senderName: string;
  senderAvatarUrl: string | null;
}

export interface ConversationPreview {
  id: string;
  businessId: string;
  userId: string;
  lastMessageAt: string | null;
  createdAt: string;
  lastMessage: {
    body: string;
    senderId: string;
    createdAt: string;
  } | null;
  unreadCount: number;
  otherParticipant: {
    name: string;
    avatarUrl: string | null;
  } | null;
  businessName: string | null;
}

export async function getConversations() {
  return apiClient<{ conversations: ConversationPreview[] }>(
    "/messages/conversations"
  );
}

export async function startConversation(businessId: string, body: string) {
  return apiClient<{ conversationId: string; messageId: string }>(
    "/messages/conversations",
    { method: "POST", body: { businessId, body } }
  );
}

export async function getMessages(
  conversationId: string,
  cursor?: string,
  limit = 50
) {
  const params = new URLSearchParams({ limit: String(limit) });
  if (cursor) params.set("cursor", cursor);
  return apiClient<{ messages: MessageWithSender[]; nextCursor: string | null }>(
    `/messages/conversations/${conversationId}?${params}`
  );
}

export async function sendMessage(conversationId: string, body: string) {
  return apiClient<{ message: Message }>(
    `/messages/conversations/${conversationId}`,
    { method: "POST", body: { body } }
  );
}

export async function markRead(conversationId: string) {
  return apiClient<{ success: boolean }>(
    `/messages/conversations/${conversationId}/read`,
    { method: "PATCH" }
  );
}

export async function getUnreadCount() {
  return apiClient<{ unreadCount: number }>("/messages/unread-count");
}

export async function pollMessages(since: string) {
  return apiClient<{ messages: MessageWithSender[]; serverTime: string }>(
    `/messages/poll?since=${encodeURIComponent(since)}`
  );
}
